/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PurchaseCancelInfoOrderInfoVo
 */
export interface PurchaseCancelInfoOrderInfoVo {
    /**
     * 订单ID
     * @type {number}
     * @memberof PurchaseCancelInfoOrderInfoVo
     */
    orderId?: number;
    /**
     * 分裂出去的订单ID数组
     * @type {Array<number>}
     * @memberof PurchaseCancelInfoOrderInfoVo
     */
    splitOrderIds?: Array<number>;
    /**
     * 订单编码
     * @type {string}
     * @memberof PurchaseCancelInfoOrderInfoVo
     */
    orderCode?: string;
    /**
     * 用户名称
     * @type {string}
     * @memberof PurchaseCancelInfoOrderInfoVo
     */
    userName?: string;
    /**
     * 用户编码
     * @type {string}
     * @memberof PurchaseCancelInfoOrderInfoVo
     */
    userCode?: string;
    /**
     * 仓库信息
     * @type {string}
     * @memberof PurchaseCancelInfoOrderInfoVo
     */
    warehouseInfo?: string;
    /**
     * 运单数
     * @type {number}
     * @memberof PurchaseCancelInfoOrderInfoVo
     */
    totalTrackingNumbers?: number;
    /**
     * 接收人名称
     * @type {string}
     * @memberof PurchaseCancelInfoOrderInfoVo
     */
    receiverName?: string;
    /**
     * CTMS类型 1 企业  2 个人
     * @type {number}
     * @memberof PurchaseCancelInfoOrderInfoVo
     */
    ctmsType?: number;
    /**
     * 平台采购订单数
     * @type {number}
     * @memberof PurchaseCancelInfoOrderInfoVo
     */
    totalPlatformPurchaseNos?: number;
    /**
     * 采购金额（人民币）
     * @type {number}
     * @memberof PurchaseCancelInfoOrderInfoVo
     */
    purchaseAmount?: number;
    /**
     * 采购报价时间
     * @type {string}
     * @memberof PurchaseCancelInfoOrderInfoVo
     */
    purchaseTime?: string;
    /**
     * 用户ID
     * @type {number}
     * @memberof PurchaseCancelInfoOrderInfoVo
     */
    userId?: number;
    /**
     * 仓库ID
     * @type {number}
     * @memberof PurchaseCancelInfoOrderInfoVo
     */
    warehouseId?: number;
    /**
     * 仓库名称
     * @type {string}
     * @memberof PurchaseCancelInfoOrderInfoVo
     */
    warehouseName?: string;
    /**
     * 商品总数量
     * @type {number}
     * @memberof PurchaseCancelInfoOrderInfoVo
     */
    goodsTotalCount?: number;
    /**
     * 商品总金额（人民币）
     * @type {number}
     * @memberof PurchaseCancelInfoOrderInfoVo
     */
    goodsTotalPriceCny?: number;
    /**
     * 商品总金额（韩币）
     * @type {number}
     * @memberof PurchaseCancelInfoOrderInfoVo
     */
    goodsTotalPriceKrw?: number;
    /**
     * 商品总金额（美元）
     * @type {number}
     * @memberof PurchaseCancelInfoOrderInfoVo
     */
    goodsTotalPriceUsd?: number;
    /**
     * 订单状态
     * @type {number}
     * @memberof PurchaseCancelInfoOrderInfoVo
     */
    orderStatus?: number;
    /**
     * 订单状态名称
     * @type {string}
     * @memberof PurchaseCancelInfoOrderInfoVo
     */
    orderStatusName?: string;
    /**
     * 管理员备注
     * @type {string}
     * @memberof PurchaseCancelInfoOrderInfoVo
     */
    adminRemark?: string;
}

/**
 * Check if a given object implements the PurchaseCancelInfoOrderInfoVo interface.
 */
export function instanceOfPurchaseCancelInfoOrderInfoVo(value: object): value is PurchaseCancelInfoOrderInfoVo {
    return true;
}

export function PurchaseCancelInfoOrderInfoVoFromJSON(json: any): PurchaseCancelInfoOrderInfoVo {
    return PurchaseCancelInfoOrderInfoVoFromJSONTyped(json, false);
}

export function PurchaseCancelInfoOrderInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseCancelInfoOrderInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'splitOrderIds': json['splitOrderIds'] == null ? undefined : json['splitOrderIds'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'warehouseInfo': json['warehouseInfo'] == null ? undefined : json['warehouseInfo'],
        'totalTrackingNumbers': json['totalTrackingNumbers'] == null ? undefined : json['totalTrackingNumbers'],
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'ctmsType': json['ctmsType'] == null ? undefined : json['ctmsType'],
        'totalPlatformPurchaseNos': json['totalPlatformPurchaseNos'] == null ? undefined : json['totalPlatformPurchaseNos'],
        'purchaseAmount': json['purchaseAmount'] == null ? undefined : json['purchaseAmount'],
        'purchaseTime': json['purchaseTime'] == null ? undefined : json['purchaseTime'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'warehouseName': json['warehouseName'] == null ? undefined : json['warehouseName'],
        'goodsTotalCount': json['goodsTotalCount'] == null ? undefined : json['goodsTotalCount'],
        'goodsTotalPriceCny': json['goodsTotalPriceCny'] == null ? undefined : json['goodsTotalPriceCny'],
        'goodsTotalPriceKrw': json['goodsTotalPriceKrw'] == null ? undefined : json['goodsTotalPriceKrw'],
        'goodsTotalPriceUsd': json['goodsTotalPriceUsd'] == null ? undefined : json['goodsTotalPriceUsd'],
        'orderStatus': json['orderStatus'] == null ? undefined : json['orderStatus'],
        'orderStatusName': json['orderStatusName'] == null ? undefined : json['orderStatusName'],
        'adminRemark': json['adminRemark'] == null ? undefined : json['adminRemark'],
    };
}

export function PurchaseCancelInfoOrderInfoVoToJSON(json: any): PurchaseCancelInfoOrderInfoVo {
    return PurchaseCancelInfoOrderInfoVoToJSONTyped(json, false);
}

export function PurchaseCancelInfoOrderInfoVoToJSONTyped(value?: PurchaseCancelInfoOrderInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'splitOrderIds': value['splitOrderIds'],
        'orderCode': value['orderCode'],
        'userName': value['userName'],
        'userCode': value['userCode'],
        'warehouseInfo': value['warehouseInfo'],
        'totalTrackingNumbers': value['totalTrackingNumbers'],
        'receiverName': value['receiverName'],
        'ctmsType': value['ctmsType'],
        'totalPlatformPurchaseNos': value['totalPlatformPurchaseNos'],
        'purchaseAmount': value['purchaseAmount'],
        'purchaseTime': value['purchaseTime'],
        'userId': value['userId'],
        'warehouseId': value['warehouseId'],
        'warehouseName': value['warehouseName'],
        'goodsTotalCount': value['goodsTotalCount'],
        'goodsTotalPriceCny': value['goodsTotalPriceCny'],
        'goodsTotalPriceKrw': value['goodsTotalPriceKrw'],
        'goodsTotalPriceUsd': value['goodsTotalPriceUsd'],
        'orderStatus': value['orderStatus'],
        'orderStatusName': value['orderStatusName'],
        'adminRemark': value['adminRemark'],
    };
}

